module.exports = __webpack_public_path__ + "2ba178393c10f1b6471163ad4b21cd2c.svg";